import { MenuItem } from 'primeng/api';
import { AuditableModel } from '../../../Common/Misc/models/auditable.model';
export class NewsroomSideBarItemModel implements AuditableModel {
    public id: number;
    public name: string;
    public status: string;
    public options?: MenuItem[];
    public createdDate: Date;
    public createdByUserId: number;
    public modifiedDate: Date;
    public modifiedByUserId: number;
    public hidden?: boolean;
}
